import { render, staticRenderFns } from "./AddFryPurchase.vue?vue&type=template&id=295c2ad2&"
import script from "./AddFryPurchase.vue?vue&type=script&lang=js&"
export * from "./AddFryPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddFryPurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports